module.exports = __webpack_public_path__ + "static/img/10015.e80c92d7.png";